(function(){
  const toggle=document.querySelector('[data-menu-toggle]');
  const nav=document.querySelector('[data-mobile-nav]');
  if(toggle&&nav){toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')==='true';toggle.setAttribute('aria-expanded',String(!open));nav.classList.toggle('is-open',!open)});nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{toggle.setAttribute('aria-expanded','false');nav.classList.remove('is-open')}));}
  document.querySelectorAll('[data-product-variant]').forEach(select=>{const container=select.closest('[data-product-info]');if(!container)return;const price=container.querySelector('[data-current-price]');const button=container.querySelector('[data-add-button]');select.addEventListener('change',()=>{const option=select.selectedOptions[0];if(price&&option.dataset.price)price.textContent=option.dataset.price;if(button)button.disabled=option.dataset.available!=='true';});});
})();

/* V10: four independent scent selections; duplicates are allowed. */
document.querySelectorAll('[data-v10-builder]').forEach(function(builder){
 const selects=Array.from(builder.querySelectorAll('[data-v10-scent]'));
 const count=builder.querySelector('[data-v10-count]');
 const summary=builder.querySelector('[data-v10-summary]');
 const submit=builder.querySelector('[data-v10-submit]');
 function update(){
  const values=selects.map(s=>s.value.trim()).filter(Boolean);
  if(count)count.textContent=values.length+' of 4 selected';
  if(summary)summary.textContent=values.length===4?'Your kit: '+values.join(' · '):'Select '+(4-values.length)+' more '+(4-values.length===1?'fragrance':'fragrances')+' to complete your kit.';
  if(submit)submit.disabled=values.length!==4;
 }
 selects.forEach(s=>s.addEventListener('change',update));
 update();
});
